import { Binder, BinderPropertyDescriptor, IBinding } from "../../../binding/binding";
import { BindingPrototype } from "../../prototype/bindingPrototype";
import { HtmlBridgePrototype } from "../../prototype/htmlBridgePrototype";
import { View } from "../../../uiPatterns/mvvm/view";
import { ViewModel } from "../../../uiPatterns/mvvm/viewmodel";
import { HtmlBridge } from "../htmlBridge";

export class StyleHtmlBridgePrototype extends HtmlBridgePrototype{
    public styleName:string;
    createInternal(view: View<ViewModel>, node: Node): HtmlBridge {
        let bridge = new StyleHtmlBridge(this);
        bridge.create(view,node);
        return bridge;
    }
}

class StyleHtmlBridge extends HtmlBridge{
    
    private styleName:string;
    private binding:IBinding;
    private element:HTMLElement;
    private bindingPrototype : BindingPrototype;
    
    constructor(prototype:StyleHtmlBridgePrototype) {
        super();
        this.bindingPrototype = prototype.binding;
        this.styleName = prototype.styleName;
    }
    
    public set value(v: string) { 
        this._value = v; 
        this.element.style[this.styleName] = this.value;
    } public get value(): string { return this._value;} private _value: string;
    
    public create(view: View<ViewModel>, node: Node){
        this.element = node as HTMLElement;
        this.binding = this.bindingPrototype.create(view,new BinderPropertyDescriptor(this,'value'));
    }

    release() {
        this.binding.release();
    }

}